export const ANALYTICS_SUMMARY_REQUEST = 'ANALYTICS_SUMMARY_REQUEST';
export const ANALYTICS_SUMMARY_SUCCESS = 'ANALYTICS_SUMMARY_SUCCESS';
export const ANALYTICS_SUMMARY_FAIL = 'ANALYTICS_SUMMARY_FAIL';

export const TOP_PRODUCTS_REQUEST = 'TOP_PRODUCTS_REQUEST';
export const TOP_PRODUCTS_SUCCESS = 'TOP_PRODUCTS_SUCCESS';
export const TOP_PRODUCTS_FAIL = 'TOP_PRODUCTS_FAIL';

export const TOP_CUSTOMERS_REQUEST = 'TOP_CUSTOMERS_REQUEST';
export const TOP_CUSTOMERS_SUCCESS = 'TOP_CUSTOMERS_SUCCESS';
export const TOP_CUSTOMERS_FAIL = 'TOP_CUSTOMERS_FAIL';

export const SALES_DATA_REQUEST = 'SALES_DATA_REQUEST';
export const SALES_DATA_SUCCESS = 'SALES_DATA_SUCCESS';
export const SALES_DATA_FAIL = 'SALES_DATA_FAIL';

export const SET_ANALYTICS_DATE_RANGE = 'SET_ANALYTICS_DATE_RANGE';
export const SET_ANALYTICS_FINANCIAL_YEAR = 'SET_ANALYTICS_FINANCIAL_YEAR';

export const ANALYTICS_CLEAR_ERRORS = 'ANALYTICS_CLEAR_ERRORS';
